"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreationAuth = exports.StandardAuth = exports.ManageAuth = exports.AccountAuth = exports.Auth = exports.AuthAgency = exports.ReportingFeature = exports.StationBoardFeature = exports.FeatureTrialStatus = void 0;
var cerealParse_1 = require("../cerealParse");
/**
 * FeatureTrialStatus enum comment.
 */
var FeatureTrialStatus;
(function (FeatureTrialStatus) {
    FeatureTrialStatus[FeatureTrialStatus["ready"] = 0] = "ready";
    FeatureTrialStatus[FeatureTrialStatus["active"] = 1] = "active";
    FeatureTrialStatus[FeatureTrialStatus["used"] = 2] = "used";
})(FeatureTrialStatus = exports.FeatureTrialStatus || (exports.FeatureTrialStatus = {}));
/**
 * Class representing a station board feature and providing a static parse method.
 */
var StationBoardFeature = /** @class */ (function () {
    function StationBoardFeature(enabled, expiration, trialStatus) {
        this.enabled = enabled;
        this.expiration = expiration;
        this.trialStatus = trialStatus;
    }
    /**
     * Parse object potentially representing a StationBoardFeature.
     * @param o
     * @return Parse result
     */
    StationBoardFeature.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new StationBoardFeature(cerealParse_1.ParseUtils.getBoolean(o, 'enabled'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'expirationTs'), cerealParse_1.ParseUtils.getEnum(o, 'trialStatus', FeatureTrialStatus)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid StationBoardFeature: " + e.message);
        }
    };
    StationBoardFeature.prototype.toFeatureStatus = function () {
        if (!this.enabled) {
            return { type: 'disabled' };
        }
        else if (this.expiration == null) {
            return { type: 'enabled', expiration: null };
        }
        else {
            return { type: 'enabled', expiration: this.expiration };
        }
    };
    return StationBoardFeature;
}());
exports.StationBoardFeature = StationBoardFeature;
var ReportingFeature = /** @class */ (function () {
    function ReportingFeature(enabled, limit) {
        this.enabled = enabled;
        this.limit = limit;
    }
    ReportingFeature.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ReportingFeature(cerealParse_1.ParseUtils.getBoolean(o, 'enabled'), cerealParse_1.ParseUtils.getNumber(o, 'limit')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ReportingFeature: " + e.message);
        }
    };
    return ReportingFeature;
}());
exports.ReportingFeature = ReportingFeature;
/**
 * Class representing an auth agency and providing a static parse method.
 */
var AuthAgency = /** @class */ (function () {
    function AuthAgency(id, name, agencyKey, exposeExternalId, stationBoard, reports, supportPin) {
        this.id = id;
        this.name = name;
        this.agencyKey = agencyKey;
        this.exposeExternalId = exposeExternalId;
        this.stationBoard = stationBoard;
        this.reports = reports;
        this.supportPin = supportPin;
    }
    /**
     * Parse object potentially representing a AuthAgency.
     * @param o
     * @return Parse result
     */
    AuthAgency.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AuthAgency(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'agencyKey'), cerealParse_1.ParseUtils.getBoolean(o, 'exposeExternalId'), cerealParse_1.ParseUtils.getSubobject(o, 'stationBoard', StationBoardFeature.parse), cerealParse_1.ParseUtils.getSubobject(o, 'reporting', ReportingFeature.parse), cerealParse_1.ParseUtils.getStringOrNull(o, 'supportPin')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Agency: " + e.message);
        }
    };
    AuthAgency.notifyReplace = function () { return null; };
    return AuthAgency;
}());
exports.AuthAgency = AuthAgency;
/**
 * Class representing an auth and providing a static parse method.
 * @TODO Make model able to be generic across all sites!
 */
var Auth = /** @class */ (function () {
    function Auth(apiKey, showEula) {
        this.apiKey = apiKey;
        this.showEula = showEula;
    }
    /**
     * Parse object potentially representing an Auth.
     * @TODO Make better fix for user id issue.
     * @param o
     * @return Parse result
     */
    Auth.parse = function (o) {
        try {
            return ManageAuth.parse(o);
        }
        catch (manageErr) {
            try {
                return AccountAuth.parse(o);
            }
            catch (accountErr) {
                try {
                    var status_1 = cerealParse_1.ParseUtils.getString(o, 'status');
                    switch (status_1) {
                        case 'authenticated':
                            return StandardAuth.parse(o);
                        case 'created':
                            return CreationAuth.parse(o);
                        default:
                            return cerealParse_1.ParseUtils.parseFailure("Invalid Auth Model: Invalid type " + status_1);
                    }
                }
                catch (_a) {
                    return cerealParse_1.ParseUtils.parseFailure('Invalid Auth Model.');
                }
            }
        }
    };
    return Auth;
}());
exports.Auth = Auth;
/**
 * Class representing authorization for the accountsite.
 */
var AccountAuth = /** @class */ (function () {
    function AccountAuth(apiKey, showEula, id, email, givenName, surname, manager, receiveNotifications) {
        this.apiKey = apiKey;
        this.showEula = showEula;
        this.id = id;
        this.email = email;
        this.givenName = givenName;
        this.surname = surname;
        this.manager = manager;
        this.receiveNotifications = receiveNotifications;
    }
    /**
     * Parse object potentially representing an Auth.
     * @param o
     * @return Parse result
     */
    AccountAuth.parse = function (o) {
        return cerealParse_1.ParseUtils.parseSuccess(new AccountAuth(
        // o.id ? ParseUtils.getString(o, 'id') : ParseUtils.getString(o, 'userId'),
        cerealParse_1.ParseUtils.getString(o, 'apiKey'), cerealParse_1.ParseUtils.getBoolean(o, 'showEula'), cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'email'), cerealParse_1.ParseUtils.getString(o, 'givenName'), cerealParse_1.ParseUtils.getString(o, 'surname'), cerealParse_1.ParseUtils.getBoolean(o, 'manager'), cerealParse_1.ParseUtils.getBoolean(o, 'receiveNotifications')));
    };
    return AccountAuth;
}());
exports.AccountAuth = AccountAuth;
/**
 * Class representing authorization for the management site.
 */
var ManageAuth = /** @class */ (function () {
    function ManageAuth(id, apiKey, email, agencies, showEula, givenName, surname) {
        this.id = id;
        this.apiKey = apiKey;
        this.email = email;
        this.agencies = agencies;
        this.showEula = showEula;
        this.givenName = givenName;
        this.surname = surname;
    }
    /**
     * Parse object potentially representing an Auth.
     * @param o
     * @return Parse result
     */
    ManageAuth.parse = function (o) {
        return cerealParse_1.ParseUtils.parseSuccess(new ManageAuth(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'apiKey'), cerealParse_1.ParseUtils.getString(o, 'email'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'departments', AuthAgency.parse, 'throw'), cerealParse_1.ParseUtils.getBoolean(o, 'showEula'), cerealParse_1.ParseUtils.getString(o, 'givenName'), cerealParse_1.ParseUtils.getString(o, 'surname')));
    };
    return ManageAuth;
}());
exports.ManageAuth = ManageAuth;
/**
 * Class representing standard authorization for the support site.
 */
var StandardAuth = /** @class */ (function () {
    function StandardAuth(type, apiKey, showEula) {
        this.type = type;
        this.apiKey = apiKey;
        this.showEula = showEula;
    }
    /**
     * Parse object potentially representing an Auth.
     * @param o
     * @return Parse result
     */
    StandardAuth.parse = function (o) {
        return cerealParse_1.ParseUtils.parseSuccess(new StandardAuth('authenticated', cerealParse_1.ParseUtils.getString(o, 'apiKey'), false));
    };
    return StandardAuth;
}());
exports.StandardAuth = StandardAuth;
/**
 * Class representing creation authorization for the support site.
 */
var CreationAuth = /** @class */ (function () {
    function CreationAuth(type, totpKey, totpKeyQrData, apiKey, showEula) {
        this.type = type;
        this.totpKey = totpKey;
        this.totpKeyQrData = totpKeyQrData;
        this.apiKey = apiKey;
        this.showEula = showEula;
    }
    /**
     * Parse object potentially representing an Auth.
     * @param o
     * @return Parse result
     */
    CreationAuth.parse = function (o) {
        return cerealParse_1.ParseUtils.parseSuccess(new CreationAuth('created', cerealParse_1.ParseUtils.getString(o, 'totpKey'), cerealParse_1.ParseUtils.getString(o, 'totpQr'), '', false));
    };
    return CreationAuth;
}());
exports.CreationAuth = CreationAuth;
// Idea for new models
// /** Represents an auth model */
// export class AccAuth {
//   constructor(
//     public apiKey: string,
//     public email: string,
//     public showEula: boolean,
//     public givenName: string,
//     public surname: string,
//   ) { }
// }
// /** Represents an auth model */
// export class ManAuth {
//   constructor(
//     public id: string,
//     public apiKey: string,
//     public email: string,
//     public agencies: AuthAgency[],
//     public showEula: boolean,
//     public givenName: string,
//     public surname: string,
//   ) { }
// }
// // /** Represents an auth model */
// // export class UniAuth {
// //   constructor(
// //     public apiKey: string,
// //     public email: string,
// //     public name: string,
// //     public type: string,
// //     public showEula: boolean,
// //     public dutyStatus: DutyStatus,
// //     public allowNotifications: boolean,
// //     public devices: LocationDevice[],
// //     public locationPrivacy: LocationPrivacy,
// //     public streams: Stream[],
// //   ) { }
// //   static parse(o: any): ParseResult<Auth> {
// //     try {
// //       const type = ParseUtils.getString(o, 'type');
// //       let name;
// //       if (type == 'user') {
// //         name = `${ParseUtils.getString(o, 'firstName')} ${ParseUtils.getString(o, 'lastName')}`;
// //       } else {
// //         name = ParseUtils.getString(o, 'name');
// //       }
// //       return ParseUtils.parseSuccess(new Auth(
// //         ParseUtils.getString(o, 'apiKey'),
// //         ParseUtils.getString(o, 'email'),
// //         name,
// //         type,
// //         ParseUtils.getBoolean(o, 'showEula'),
// //         ParseUtils.getBoolean(o, 'receiveNotifications') ? DutyStatus.on : DutyStatus.off,
// //         ParseUtils.getBoolean(o, 'receivePush'),
// //         ParseUtils.getArrayOfSubobjects(o, 'devices', LocationDevice.parse, 'warn'),
// //         ParseUtils.getEnum(o, 'locationPrivacy', LocationPrivacy),
// //         ParseUtils.getArrayOfSubobjects(o, 'audioStreams', Stream.parse, 'warn').sort(Stream.compare),
// //       ));
// //     } catch (e) {
// //       return ParseUtils.parseFailure<Auth>(`Invalid Auth Model: ${e.message}`);
// //     }
// //   }
// // }
// export type NewAuth = AccAuth | ManAuth;
// export function parseAuth<T extends NewAuth>(o: any): ParseResult<T> {
//   try {
//     return ParseUtils.parseSuccess(new AccAuth(
//       // o.id ? ParseUtils.getString(o, 'id') : ParseUtils.getString(o, 'userId'),
//       ParseUtils.getString(o, 'apiKey'),
//       ParseUtils.getString(o, 'email'),
//       ParseUtils.getBoolean(o, 'showEula'),
//       ParseUtils.getString(o, 'firstName'),
//       ParseUtils.getString(o, 'lastName'),
//       ParseUtils.getArrayOfSubobjects(o, 'departments', AuthAgency.parse, 'ignore'),
//     ));
//   } catch (e) {
//     try {
//       return ParseUtils.parseSuccess(new Auth(
//         ParseUtils.getString(o, 'id'),
//         ParseUtils.getString(o, 'apiKey'),
//         ParseUtils.getString(o, 'email'),
//         ParseUtils.getArrayOfSubobjects(o, 'departments', AuthAgency.parse, 'throw'),
//         ParseUtils.getBoolean(o, 'showEula'),
//         ParseUtils.getString(o, 'givenName'),
//         ParseUtils.getString(o, 'surname'),
//       ));
//     } catch (e) {
//       return ParseUtils.parseFailure<Auth>(`Invalid Auth Model: ${e.message}`);
//     }
//   }
// }
//# sourceMappingURL=auth.js.map